import { renderNodeRule, StructuredText } from 'react-datocms';

import { Header1, Header2, Header3, Link, P1 } from '@bumble/ui-kit';
import { isHeading, isLink, isParagraph } from 'datocms-structured-text-utils';

import styles from './rich-text.module.scss';

interface Props {
  data: any;
}

export default function RichText({ data }: Props) {
  return (
    <div className={styles.rich__text}>
      <StructuredText
        data={data}
        customNodeRules={[
          renderNodeRule(isHeading, ({ node, children }) => {
            const { level } = node;

            switch (level) {
              case 1:
                return <Header1>{children}</Header1>;
              case 2:
                return <Header2>{children}</Header2>;
              default:
                return <Header3>{children}</Header3>;
            }
          }),

          renderNodeRule(isParagraph, ({ children }) => {
            return <P1>{children}</P1>;
          }),

          renderNodeRule(isLink, ({ node, children }) => {
            return <Link href={node.url}>{children}</Link>;
          }),
        ]}
      />
    </div>
  );
}
